import styled from "styled-components";



export const Box = styled.div`
  text-align: center;
  font-family: roboto, sans-serif;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 30px;
  width: fit-content;
  margin: 60px auto;
  text-align: center;
  border-radius: 10px;
`;

export const Image = styled.img`
  width: 100px;
  margin-top: 8%;
`;

export const Button = styled.button`
  background-color: green;
  color: white;
  padding: 5px;
  font-size: 16px;
  border-radius: 6px;
`;
